import '.bz{flex-shrink:0;}.ssr-plugin'
import '.c2{width:20rem;}.ssr-plugin'
import '.aj{border:var(--blue-border);}.ssr-plugin'
import '.bb{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.ab{border-radius:1.25rem;}.ssr-plugin'
import '.c0{padding:1rem;}.ssr-plugin'
import '.h{display:flex;}.ssr-plugin'
import '.k{gap:2rem;}.ssr-plugin'
import '.c3{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="bz c2 aj bb ab c0"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="h k c3"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
